import { Component, inject, signal } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { MOCK_FORM_FIELDS } from '@demo/data/demo-form-builder.const';
import { DemoFormBuilderService } from '@demo/module-definition/demo-form-builder/demo-form-builder.service';
import {
  DEMO_DESIGNER_SCREEN,
  DEMO_SCREEN_DESIGNER_PROVIDERS,
} from '@demo/module-definition/demo-form-builder/demo-screen-designer.providers';
import { GridFormViewComponent } from '@module-definition/form/grid-form-view/grid-form-view.component';
import { GridFormComponent } from '@module-definition/form/grid-form/grid-form.component';
import { ScreenDesignerComponent } from '@module-instance/modules/dialogs/module-config/screen-designer/screen-designer.component';
import { CipoControl, CipoFieldConfig, CipoForm } from '@shared/components/fields/common';

type DemoMode = 'edit' | 'view' | 'designer';

@Component({
  selector: 'app-demo-form-builder',
  templateUrl: './demo-form-builder.component.html',
  imports: [
    FlexLayoutModule,
    GridFormComponent,
    GridFormViewComponent,
    MatButtonModule,
    MatButtonToggleModule,
    ScreenDesignerComponent,
  ],
  providers: [DEMO_SCREEN_DESIGNER_PROVIDERS],
  host: { class: 'cipo--display--block cipo--height--full' },
})
export class DemoFormBuilderComponent {
  fb = inject(FormBuilder);
  demoService = inject(DemoFormBuilderService);

  items = signal(MOCK_FORM_FIELDS);
  form: CipoForm = this.fb.group({});
  fieldsData = signal<Record<string, CipoFieldConfig>>({});
  mode = signal<DemoMode>('edit');
  designerScreen = DEMO_DESIGNER_SCREEN;

  constructor() {
    this.demoService.getFormData().subscribe(fields => {
      const fieldsData: Record<string, CipoFieldConfig> = {};
      fields.forEach(item => {
        const control = new CipoControl(item.value, item.fieldOptions);
        this.form.addControl(item.id, control);
        fieldsData[item.id] = item.fieldOptions;
      });
      this.fieldsData.set(fieldsData);
    });
  }

  logItems() {
    console.log(this.form.value);
  }
}
